import * as React from "react"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {Button, Checkbox, TableSortLabel, TextField, Toolbar, Tooltip} from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';

interface IHeaderProps {
    t: any;
    data: any;
    title: string;
    converter?: Array<Converter>;
    buttons?: Array<TableButton>;
    //onRowSelected? : any (function mit data des selected items)
    selectable?: boolean;
    isLoading?: boolean;
}

interface Converter {
    property: string;
    convert: any;
}

interface TableButton {
    title: string;
    onClick: any;
    // undefined = always, false = single, true = multi
    selectionMulti?: boolean;
}

interface IHeaderState {
    rows: Array<any>;
    selected: Array<number>;
    rowsPerPage: number;
    page: number;
    order: string;
    orderBy: string;
    buttons: Array<TableButton>;
    filterText: string;
}

interface TableRow {
    index: number;
    entity: any;
}

class HamaTable extends React.Component<IHeaderProps, IHeaderState> {

    state = {
        rows: this.props.data,
        selected: new Array<number>(),
        rowsPerPage: 15,
        page: 0,
        order: 'asc',
        orderBy: '',
        buttons: this.props.buttons ? this.props.buttons : new Array<TableButton>(),
        filterText: '',
        isLoading: this.props.isLoading != undefined ? this.props.isLoading : true
    }

    tableRows = new Array<TableRow>();
    sortedAndFilteredTableRows = new Array<TableRow>();
    keysOfData: string[] = [];

    render() {
        console.log("HamaTable render");
        if (this.state.rows === null || this.state.rows === undefined) {
            return (<div></div>);
        }
        const dataRows = this.state.rows;
        const page = this.state.page;
        const rowsPerPage = this.state.rowsPerPage;
        const rowCount = dataRows.length;

        const numSelected = this.state.selected.length;
        if (dataRows.length > 0) {
            this.keysOfData = Object.keys(dataRows[0]);
        }
        //if (this.tableRows.length === 0) {
            let index = 0;
            this.tableRows = dataRows.map((row: entityType) => ({index: index = index + 1, entity: row}));
        //}
        type entityType = typeof dataRows[0];
        this.sortedAndFilteredTableRows = this.tableRows.sort(this.handleSort.bind(this)).filter(this.handleFilter.bind(this));
        return (
            <Paper style={{padding: "10px", margin: "25px"}}>
                <Toolbar>
                    {numSelected > 0 && this.props.selectable ? (
                        <div style={{display: 'flex', width: '100%'}}>
                            <Typography color="inherit" variant="h6">
                                {numSelected} {this.props.t('HamaTable.selected')} {rowCount}
                            </Typography>
                            {this.getHeaderButtons(numSelected)}
                            {this.createFilterTextField()}
                        </div>
                    ) : (
                        <div style={{display: 'flex', width: '100%'}}>
                            <Typography variant="h6" id="tableTitle">
                                {this.props.t(this.props.title + '.title')}
                            </Typography>
                            {this.keysOfData.length === 0 && this.state.isLoading ? (<CircularProgress size={30}/>) : ''}
                            {this.getHeaderButtons(numSelected)}
                            {this.createFilterTextField()}
                        </div>
                    )}
                </Toolbar>

                <Table>
                    <TableHead>
                        <TableRow>
                            {this.props.selectable ?
                                (<TableCell padding="checkbox">
                                    <Checkbox
                                        indeterminate={numSelected > 0 && numSelected < rowCount}
                                        checked={numSelected === rowCount}
                                        onChange={this.onSelectAllClick}
                                    /></TableCell>)
                                : null
                            }
                            {this.keysOfData.map(
                                header => (<TableCell key={header} align="left">
                                    <Tooltip
                                        title="Sort"
                                        enterDelay={300}>
                                        <TableSortLabel
                                            active={this.state.orderBy === header}
                                            direction={this.state.order.match('asc') ? 'asc' : 'desc'}
                                            onClick={() => this.sort(header)}>
                                            {this.props.t(this.props.title + '.' + header)}
                                        </TableSortLabel>
                                    </Tooltip>
                                </TableCell>))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.sortedAndFilteredTableRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row: TableRow) => (
                            <TableRow key={row.index} hover onClick={event => this.handleClick(event, row.index)}>
                                {this.props.selectable ? (<TableCell align="left" padding="checkbox"><Checkbox
                                    checked={this.isSelected(row.index)}/></TableCell>) : null}
                                {this.keysOfData.map(key => (
                                    <TableCell key={key} align="left">{this.getValueForKey(row.entity, key)}</TableCell>))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 25]}
                    component="div"
                    count={this.sortedAndFilteredTableRows.length}
                    rowsPerPage={rowsPerPage}
                    labelRowsPerPage={this.props.t('HamaTable.rowsPerPage')}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': this.props.t('HamaTable.prevPage'),
                    }}
                    nextIconButtonProps={{
                        'aria-label': this.props.t('HamaTable.nextPage'),
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </Paper>
        );
    }

    getValueForKey(entity: any, key: string) {
        let converterList = this.props.converter ? this.props.converter : [];
        let value = entity[key];
        if (converterList.length > 0) {
            let foundConverters = converterList.filter(con => con.property.match(key));
            if (foundConverters.length == 1) {
                return foundConverters[0].convert(value);
            }
        }
        return value;
    }

    getHeaderButtons(numSelected: number) {
        return this.state.buttons.filter(b => {
            if (b.selectionMulti === undefined || (b.selectionMulti && numSelected > 0) || (!b.selectionMulti && numSelected == 1)) {
                return true;
            }
            return false;
        }).map(b => (<Button variant="contained" color="primary" onClick={() => b.onClick(this.getSelectedDataRows())}
                             style={{marginLeft: '25px'}}>{this.props.t(b.title)}</Button>));
    }

    sort(key: string) {
        let ascNum = this.state.order.match('asc') ? 1 : -1;
        this.setState({order: ascNum === 1 ? 'desc' : 'asc'})
        this.setState({orderBy: key});
    }

    handleSort(a: any, b: any) {
        let ascNum = this.state.order.match('asc') ? 1 : -1;
        if (b.entity[this.state.orderBy] < a.entity[this.state.orderBy]) {
            return -1 * ascNum;
        }
        if (b.entity[this.state.orderBy] > a.entity[this.state.orderBy]) {
            return 1 * ascNum;
        }
        return 0;
    }

    filter(event: React.ChangeEvent) {
        let value: string = (event.target as HTMLInputElement).value;
        this.setState({filterText: value});
    }

    createFilterTextField() {
        return (
            <div style={{marginLeft: 'auto'}}>
                <TextField
                    onChange={this.filter.bind(this)}
                    defaultValue={this.state.filterText}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon/>
                            </InputAdornment>
                        ),
                    }}>
                </TextField>
            </div>);
    }

    handleFilter(row: any) {
        let exists = false;
        this.keysOfData.forEach(key => {
            let data: string = row.entity[key];
            //only string right now; improve for other types
            if (typeof data == "string" && !(data === null || data === undefined) && data.toLowerCase().indexOf(this.state.filterText.toLowerCase()) > -1) {
                exists = true;
            }
        })
        return exists;
    }

    handleClick(event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, index: number): void {
        if (!this.isSelected(index)) {
            this.sortedAndFilteredTableRows.filter((row: TableRow) => row.index === index).forEach((row: TableRow) => this.state.selected.push(row.index));
        } else {
            this.state.selected.splice(this.state.selected.indexOf(index), 1);
        }
        this.setState({selected: this.state.selected}); // to update UI
    }

    isSelected = (index: number): boolean => this.state.selected.indexOf(index) !== -1;

    getSelectedDataRows(): Array<any> {
        let selections = new Array<any>();
        let data = this.tableRows;//.sort(this.handleSort.bind(this));
        this.state.selected.forEach(i => {
            data.filter(row => i === row.index).forEach(row => selections.push(row.entity))
        });
        return selections;
    }

    handleChangePage = (event: any, page: number) => {
        this.setState({page: page});
    };

    handleChangeRowsPerPage = (event: any) => {
        this.setState({rowsPerPage: event.target.value});
    };

    onSelectAllClick = (event: any) => {
        this.state.selected.splice(0, this.tableRows.length);
        if (event.target.checked) {
            this.tableRows.forEach((row: TableRow) => this.state.selected.push(row.index));
        }
        this.setState({selected: this.state.selected});
    }

    shouldComponentUpdate(nextProps: any, nextState: any) {
        if (JSON.stringify(nextProps.data) != JSON.stringify(this.state.rows) || JSON.stringify(nextProps.isLoading) != JSON.stringify(this.state.isLoading)) {
            nextState.rows = nextProps.data;
            nextState.isLoading = nextProps.isLoading;
            nextState.selected = [];
        }
        return true;
    }
}
export default HamaTable;